import { BuildingContractLengthDetailsDto } from '@client/api';
import i18n from 'i18next';

export const transformJsonToExcelFormat = (data: BuildingContractLengthDetailsDto[], selectedRows: Set<string>) => {
  const rows: Record<string, any>[] = [];
  if (data.length === 0) return [{ [i18n.t('noData', { ns: 'reporting' })]: null }];
  data.forEach((item) => {
    if (selectedRows.has(item.buildingName) || selectedRows.size === 0) {
      rows.push({
        [i18n.t('contractLength.building', { ns: 'reporting' })]: item.buildingName,
        [i18n.t('contractLength.tenants', { ns: 'reporting' })]: item.numberOfTenants,
        [i18n.t('contractLength.remainingMonths', { ns: 'reporting' })]: null,
        [i18n.t('contractLength.startDate', { ns: 'reporting' })]: null,
        [i18n.t('contractLength.endDate', { ns: 'reporting' })]: null,
        [i18n.t('contractLength.totalMonths', { ns: 'reporting' })]: null,
      });
      item.tenants.forEach((tenant) => {
        rows.push({
          [i18n.t('contractLength.building', { ns: 'reporting' })]: null,
          [i18n.t('contractLength.tenants', { ns: 'reporting' })]: tenant.name,
          [i18n.t('contractLength.remainingMonths', { ns: 'reporting' })]: tenant.remainingContractLengthYears,
          [i18n.t('contractLength.startDate', { ns: 'reporting' })]: tenant.startDate,
          [i18n.t('contractLength.endDate', { ns: 'reporting' })]: tenant.endDate,
          [i18n.t('contractLength.totalMonths', { ns: 'reporting' })]: tenant.totalContractLengthYears,
        });
      });
    }
  });
  return rows;
};
